import _styled from "@emotion/styled/base";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { keyframes, useTheme } from '@emotion/react';
import { forwardRef, useId, useImperativeHandle, useRef, useState } from 'react';
import ReactSelect from 'react-select';
import * as components from '../../primitives/Select/components/index.js';
export const customStyles = {
  container: (provided, state) => {
    const highlight = keyframes`
      from {
        outline-color: ${state.theme.app.colors.backgroundPrimary};
      }
      to {
        outline-color: ${state.theme.app.colors.systemWarning};
      }
    `;
    return {
      ...provided,
      minWidth: '0',
      borderRadius: '5px',
      outline: '2px solid transparent',
      ...(state.selectProps.highlighted && {
        animation: `${highlight} 0.5s forwards`
      }),
      ...(state.selectProps.fullWidth && {
        width: '100%'
      })
    };
  },
  indicatorSeparator: () => ({
    display: 'none'
  }),
  // @ts-expect-error TS(7006) FIXME: Parameter 'provided' implicitly has an 'any' type.
  menu: (provided, state) => ({
    ...provided,
    borderRadius: '5px',
    boxShadow: '0px 0px 24px rgba(0, 0, 0, 0.08), 0px 8px 24px rgba(0, 0, 0, 0.1)',
    zIndex: state.theme.app.stacking.zIndexControlsPriority
  }),
  // @ts-expect-error TS(7006) FIXME: Parameter 'provided' implicitly has an 'any' type.
  group: (provided, state) => ({
    '& + &': {
      borderTop: `1px solid ${state.theme.app.colors.borderSecondary}`
    }
  }),
  groupHeading: () => ({
    display: 'none'
  }),
  input: provided => ({
    ...provided,
    margin: 0,
    padding: 0,
    // This is making the input element wrapper div with the inline `inline-block` style explicitly set by React Select fit correctly in our layout
    lineHeight: '1rem'
  }),
  // @ts-expect-error TS(7006) FIXME: Parameter 'provided' implicitly has an 'any' type.
  dropdownIndicator: (provided, state) => ({
    ...provided,
    padding: '0',
    ...(state.isDisabled ? {
      color: state.theme.app.colors.contentStateDisabled
    } : {
      color: state.theme.app.colors.interactionSecondary,
      '&:hover': {
        color: state.theme.app.colors.interactionSecondary
      }
    })
  })
};
export const Select = /*#__PURE__*/_styled(forwardRef(function Select(props, ref) {
  const {
    styles,
    components: componentsProperty,
    message,
    pinnedPlaceholder = false,
    invalid = false,
    highlighted: controlledHighlighted,
    size = 'medium',
    highlightBehaviour = 'onFocus',
    centered = false,
    disabled,
    customMenuListHeight,
    menuShouldScrollIntoView,
    onMenuOpen,
    id: propsId,
    controlIcon,
    dropdownIndicatorIcon,
    formatSingleValue,
    menuListProps,
    multiValuePrefix
  } = props;
  const appTheme = useTheme();
  const selectRef = useRef();
  const [highlighted, setHighlighted] = useState(false);
  const autoId = useId();
  const id = propsId || autoId;
  const selectProps = {
    ...props,
    isPinned: pinnedPlaceholder,
    highlighted: controlledHighlighted == null ? highlighted : controlledHighlighted,
    size,
    invalid,
    message,
    highlightBehaviour,
    centered,
    controlIcon,
    dropdownIndicatorIcon,
    formatSingleValue,
    menuListProps,
    multiValuePrefix
  };
  useImperativeHandle(ref, () => ({
    focus: () => {
      selectRef.current.focus();
    },
    highlightOn: () => {
      setHighlighted(true);
    },
    highlightOff: () => {
      setHighlighted(false);
    }
  }));
  return _jsx(ReactSelect, {
    ...selectProps,
    ref: selectRef,
    styles: {
      ...customStyles,
      menuList: provided => ({
        ...provided,
        height: customMenuListHeight
      }),
      ...styles
    },
    components: {
      ...components,
      ...componentsProperty
    },
    // Make our own theme available inside React Select styling callbacks
    theme: theme => ({
      ...theme,
      app: appTheme
    }),
    isDisabled: disabled,
    menuShouldScrollIntoView: menuShouldScrollIntoView,
    onMenuOpen: onMenuOpen,
    inputId: id
  });
}), process.env.NODE_ENV === "production" ? {
  target: "evxrh3v0"
} : {
  target: "evxrh3v0",
  label: "Select"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");